import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alpha" }
const _hoisted_2 = { class: "alpha-checkboard-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkboard = _resolveComponent("Checkboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Checkboard)
    ]),
    _createElementVNode("div", {
      class: "alpha-gradient",
      style: _normalizeStyle({ background: _ctx.gradientColor })
    }, null, 4),
    _createElementVNode("div", {
      class: "alpha-container",
      ref: "alphaRef",
      onMousedown: _cache[0] || (_cache[0] = $event => _ctx.handleMouseDown($event))
    }, [
      _createElementVNode("div", {
        class: "alpha-pointer",
        style: _normalizeStyle({ left: _ctx.color.a * 100 + '%' })
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "alpha-picker" }, null, -1)
      ]), 4)
    ], 544)
  ]))
}